<div class="d-flex flex-column page-header flowsheet-builder">
    <div class="templateHeader d-flex">
        Flowsheet Builder - <span *ngIf="!flowSheet.name else nameOfFlowsheet">Untitled*</span>
        <ng-template #nameOfFlowsheet>{{flowSheet.name}}</ng-template>
      <div *ngIf="!isLoading">
        <button *ngIf="viewOnly && isAuthorized" (click)="inEditMode()" matTooltip="Edit" matTooltipPosition="below" class="btn actionBtn p-0"><mat-icon class="action-icon-edit">edit</mat-icon></button>
        <button *ngIf="!viewOnly" (click)="save()" matTooltip="Save" matTooltipPosition="below" class="btn actionBtn p-0" [disabled]="!(flowSheet.models.length > 0)" [ngClass]="{ 'inactiveClss': !(flowSheet.models.length > 0)}"><mat-icon class="action-icon-save"></mat-icon></button>
        <button (click)="openRunDetails()" matTooltip="View Run Details" matTooltipPosition="below" class="btn actionBtn p-0" [disabled]="!flowSheet.name" [ngClass]="{ 'inactiveClss': !flowSheet.name}"><mat-icon class="action-icon-viewRunDetails"></mat-icon></button>
        <button (click)="validateBeforeRun()" matTooltip="Run" matTooltipPosition="below" class="btn actionBtn p-0" [disabled]="!flowSheet.name || !isReadyForNewRun" [ngClass]="{ 'inactiveClss': !flowSheet.name || !isReadyForNewRun}"><mat-icon class="action-icon-run"></mat-icon></button>
        <button (click)="terminateRun()" matTooltip="Terminate" matTooltipPosition="below" class="btn actionBtn p-0" [disabled]="!flowSheet.name ||!isReadyForTerminiate" [ngClass]="{ 'inactiveClss':!flowSheet.name ||!isReadyForTerminiate}"><mat-icon class="action-icon-terminate">not_interested</mat-icon></button>
      </div>
    </div>
</div>
<div *ngIf="isLoading" class="svg-loader"></div>
<div>
  <div class="modeler">
    <div id="canvas">
      <div class="io-zoom-controls">
        <ul class="io-zoom-reset io-control io-control-list">
          <li>
            <button title="reset zoom" (click)="canvasZoomReset()">
              <span class="icon-screenshot"></span>
            </button>
          </li>
          <li>
            <hr>
          </li>
          <li>
            <button title="zoom in" (click)="canvasZoomIn()">
              <span class="icon-plus"></span>
            </button>
          </li>
          <li>
            <hr>
          </li>
          <li>
            <button href="" title="zoom out" (click)="canvasZoomOut()">
              <span class="icon-minus"></span>
            </button>
          </li>
        </ul>
      </div>
    </div>
    <div id="properties" *ngIf="!viewOnly"></div>
    <div id="customPalette" *ngIf="!viewOnly">
      <div class="pallet-nav">
        <div class="palletNav">
          <div *ngFor="let item of palletData" [ngClass]="{ 'activePallet': activPallet === item.modelType}" (click)="selectPalleteType(item.modelType)">{{item.modelType}}</div>
        </div>
      </div>
      <div class="palletContainer">
        <div class="search_box position-relative">
          <span class="searchIcon"></span>
          <input type="text" id="search" autocomplete="off" [ngModel]="searchText" (ngModelChange)="searchPallet($event)" placeholder="Search..." ngModel>
        </div> 
        <div *ngFor="let item of filteredPalletData">
          <div *ngIf="activPallet ===  item.modelType" class="palletScroll">
            <div *ngFor="let modelInfo of item.modelData" class="palletIcons" 
            (click)="selectModel(modelInfo.modelName)" (keydown)="selectModel(modelInfo.modelName);"
            ngbTooltip="{{modelInfo.modelName}}" container="body">
              <div [ngClass]="'icon-custom'">
                <img alt="modelIcon" *ngIf="modelInfo.modelImage" [src]="domSanitizer.bypassSecurityTrustUrl('data:image/svg+xml;base64,' + modelInfo.modelImage)" />
                <img alt="modelIcon" *ngIf="!modelInfo.modelImage" src="assets/bpmn/defaultModel.svg" />
              </div>
              <div class="custom-modelName">{{modelInfo.modelName}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="diagnosticsFrame">
    Diagnostics
  </div>
</div>
<ul class='custom-menu' *ngIf="showContextMenu" [style.left.px]="posX" [style.top.px]="posY">
  <li (click)="renameModel()">Rename</li>
</ul>
